// a reducer takes in 2 things:

// 1: the action (info about what happened)

// 2: a copy of the current state

function league(state = [], action) {
    // call saga to fetch the leagues from API ?
    switch (action.type) {
        case 'LEAGUE/SET':
            return action.league;
        default:
            return state;
    }
}

export default league;